<script lang="ts">
  import { faArrowUpRightFromSquare } from '@fortawesome/free-solid-svg-icons'
  import { getI18n } from '../../i18n'
  import { BUTTON_LINK_VARIANTS } from '../../categories'
  import { getPageCategory } from '../../pageCategory'
  import type { SerializedMapBlock } from '../../types'
  import ButtonLink from '../ButtonLink.svelte'
  import CopyAddressButton from '../CopyAddressButton.svelte'
  import MapView from '../MapView.svelte'
  import MirroredIcon from '../MirroredIcon.svelte'
  import PlaceAddress from '../PlaceAddress.svelte'

  let { block }: { block: SerializedMapBlock } = $props()

  const i18n = getI18n()
  const pageCategory = getPageCategory()
</script>

<div class="map-block">
  <div class="map-block-map">
    <MapView places={[block.place]} variant={pageCategory.variant} />
  </div>
  <div class="map-block-info">
    <PlaceAddress place={block.place} />
    <div class="map-block-actions">
      <CopyAddressButton place={block.place} variant={pageCategory.variant} />
      <ButtonLink href={block.place.googleMapsUrl} target="_blank" rel="noopener noreferrer" variant={BUTTON_LINK_VARIANTS[pageCategory.variant]}>
        {i18n.t('page.openInGoogleMaps')}
        {#snippet end()}<MirroredIcon icon={faArrowUpRightFromSquare} />{/snippet}
      </ButtonLink>
    </div>
  </div>
</div>

<style>
  .map-block {
    overflow: hidden;
    margin-bottom: var(--space-9);
    border: var(--border-style-2);
    border-radius: var(--radius-3);
  }

  .map-block-map {
    height: 320px;
  }

  .map-block-info {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    gap: var(--space-5);
    padding: var(--space-6) var(--space-7);
    border-block-start: var(--border-style-2);
    background-color: var(--color-bg-muted);
  }

  .map-block-actions {
    display: flex;
    flex-wrap: wrap;
    gap: var(--space-4);
  }
</style>
